import ApiPermisos from '../../services/apiPermisos'

export default {
    namespaced: true,
    state: {
        loading: false,
        loading2: false,
        loading3: false,
        loadinghis: false,
        error:{},
        erroredit:{},
        message:{},
        newGES:{},
        tableGES:{},
        tableGESemployees:{},
        ges:{},
        gesHistory:{},
        sveList:{},

        //Potencial Risk

        gesPr:{}
    },
    getters: {},
    mutations: {
        setLoading: (state, loading) => {
            state.loading = loading;
        },
        setLoading2: (state, loading2) => {
          state.loading2 = loading2;
        },
        setLoading3: (state, loading3) => {
          state.loading3 = loading3;
        },
        setLoadinghis: (state, loadinghis) => {
          state.loadinghis = loadinghis;
        },
        setError:(state, error) => {
            state.error.message = error  
        },
        setErrorEdit:(state, erroredit) => {
            state.erroredit.message = erroredit  
        },
        setMessage:(state, message) => {
            state.error = {}
            state.message = message  
        },
        setNewGES:(state, newGES) => {
            state.newGES = newGES
        },
        setGESsTable:(state,tableGES) => {
          state.tableGES = tableGES.data
        },
        setGESTableEmployees:(state,tableGESemployees) => {
          state.tableGESemployees = tableGESemployees.data
        },
        setGES:(state,ges) => {
          state.ges = ges.data
        },
        setHistoryGes:(state,gesHistory) => {
          state.gesHistory = gesHistory.data
        },
        setSVElist:(state,sveList) => {
          state.sveList = sveList.sve_lists
        },
        setCaract:(state,svecaract) => {
          state.svecaract = svecaract.caract_lists
        },

        //Potencial Risk

        setGesPotencialRisk:(state,gesPr) => {
          state.gesPr = gesPr
        },
        
    },
    actions: {   

        //Trae las listas desplegables del formulario de Creación de ausentismos

    actGetListsAbsenteeism: async ({
      commit
    }) => {
      try {
        commit('setLoading2', true);
        let response = await ApiPermisos.getListsAbsenteeism();
        commit('setLoading2', false);
        if (response.error) {
            commit('setError', response.error.trace.message[0]);
            return response.error;
        }
        else{
          commit('setListsAbsenteeism', response);
        }
      } catch (error) {
        let error2 = error.response
        commit('setError', error2.data.message);
      }
    },

       //Guarda un GES

       actSaveGES: async ({
        commit
      }, data) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.saveGES(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setNewGES', response);
          }
        } catch (error) {
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

        //Trae los GES paginados

        actGetGESTable: async ({
          commit
        }, data) => {
          try {
            commit('setLoading', true);
            let response = await ApiPermisos.getGESTable(data);
            commit('setLoading', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setGESsTable', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Trae los GES paginados

        actGetSVElist: async ({
          commit
        }, data) => {
          try {
            commit('setLoading', true);
            let response = await ApiPermisos.getSVElist(data);
            commit('setLoading', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setSVElist', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },
                
        //Traer empleados ligados a un GES

        actGetGESTableEmployees: async ({
          commit
        }, data) => {
          try {
            commit('setLoading3', true);
            let response = await ApiPermisos.getGESTableEmployees(data);
            commit('setLoading3', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setGESTableEmployees', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Guarda empleados en un GES 

        actSaveEmployeeGES: async ({
          commit
        }, data) => {
          try {
            commit('setLoading3', true);
            let response = await ApiPermisos.saveEmployeeGES(data);
            commit('setLoading3', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Elimina empleados ligados a un GES editGES

        actDeleteEmployeeGES: async ({
          commit
        }, {ges_id,employee}) => {
          try {
            commit('setLoading3', true);
            let response = await ApiPermisos.deleteEmployeeGES({ges_id,employee});
            commit('setLoading3', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Trae la información completa de un GES

        actGetGES: async ({
          commit
        }, id) => {
          try {
            commit('setLoading', true);
            let response = await ApiPermisos.getGES(id);
            commit('setLoading', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setGES', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Edita un GES

        actEditGES: async ({
          commit
        }, data) => {
          try {
            commit('setLoading2', true);
            let response = await ApiPermisos.editGES(data);
            commit('setLoading2', false);
            
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                if (response.error.detail.name !== undefined && response.error.detail.employees !== undefined){
                  commit('setErrorEdit', response.error.detail.name + ' ' + response.error.detail.employees );
                }else if(response.error.detail.name !== undefined && response.error.detail.employees === undefined){
                  commit('setErrorEdit', response.error.detail.name );
                }
                else if(response.error.detail.name === undefined && response.error.detail.employees !== undefined){
                  commit('setErrorEdit',response.error.detail.employees );
                }
                
                return response.error;
            }
            else{
              commit('setErrorEdit','');
              commit('setMessage', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Elimina un GES

        actDeleteGES: async ({
          commit
        }, id) => {
          try {
            commit('setLoading2', true);
            let response = await ApiPermisos.deleteGES(id);
            commit('setLoading2', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Trae la información completa de un GES

        actGetHistoryGES: async ({
          commit
        }, { id, page }) => {
          try {
            commit('setLoadinghis', true);
            let response = await ApiPermisos.getHistoryGES({ id, page });
            commit('setLoadinghis', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setHistoryGes', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

         //////+++++++++++ POTENCIAL RISK ++++++++++++++/////

        //Trae la información completa de un GES  

        actGetGesPotencialRisk: async ({
          commit
        }, id) => {
          try {
            commit('setLoading', true);
            let response = await ApiPermisos.getGesPotencialRisk(id);
            commit('setLoading', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setGesPotencialRisk', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Clasifica el Riesgo Potencial de un GES

        actSaveGesPotencialRisk: async ({
          commit
        }, data) => {
          try {
            commit('setLoading2', true);
            let response = await ApiPermisos.saveGesPotencialRisk(data);
            commit('setLoading2', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        // indexEmployee({ commit }, { id = 0, values = {} }) {
        //   commit('SET_PROCESSING_EMPLOYEES')
        //   commit('SET_EMPLOYEES')
        //   const { data: { data, links, meta }, error } =   ApiPermisos.indexEmployeesGES(id, values).finally(() => commit('SET_PROCESSING_EMPLOYEES', false ))
        //   if(error) { return alert(`/¡Lo sentimos!, ocurrio un error cargando los empleados. ${error.detail}`) }
        //   commit('SET_EMPLOYEES', { data, links, meta })
        // },



     


    },
  }
  